export enum BUNDLE_EXTENSIONS {
  PRODUCT = "PRODUCT",
  ATTRIBUTES = "ATTRIBUTES",
  MINT = "MINT",
  HISTORY = "HISTORY",
  DECENTRALAND = "DECENTRALAND",
  REDEEM = "REDEEM",
  PARTNER_CONTACT = "PARTNER_CONTACT",
  SHIPPING_INFO = "SHIPPING_INFO",
  POAP = "POAP",
  DESCRIPTION = "DESCRIPTION",
  POAP_CREATE = "POAP_CREATE",
  DETAILS = "DETAILS",
  CUSTOM = "CUSTOM",
  TICKET = "TICKET",
  LINKS = "LINKS",
  CHRIS_LOST_HIS_ITEMS = "CHRIS_LOST_HIS_ITEMS",
  FAROKH_LOST_HIS_ITEMS = "FAROKH_LOST_HIS_ITEMS",
  WE_COUNTDOWN = "WE_COUNTDOWN",
  VIDEO_MODAL = "VIDEO_MODAL",
  VIDEO_SECTION = "VIDEO_SECTION",
  TAPPING_NFCS = "TAPPING_NFCS",
  COLLECT_ADDRESSES = "COLLECT_ADDRESSES",
  ORDINALS = "ORDINALS",
  EMAIL = "EMAIL",
  AIRDROP = "AIRDROP",
  AIRDROP_SOL = "AIRDROP_SOL",
}
